import { baseApiClient as api } from "../baseService";
export const addTagTypes = ["treatment"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      treatmentContactQueueList: build.query<
        TreatmentContactQueueListApiResponse,
        TreatmentContactQueueListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/treatment/contact-queue/`,
          params: {
            assignee_id: queryArg.assigneeId,
            cadence_days: queryArg.cadenceDays,
            days_overdue_min: queryArg.daysOverdueMin,
            limit: queryArg.limit,
            offset: queryArg.offset,
            requires_escalation: queryArg.requiresEscalation,
            urgency: queryArg.urgency,
          },
        }),
        providesTags: ["treatment"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type TreatmentContactQueueListApiResponse =
  /** status 200  */ TreatmentContactQueueResponse;
export type TreatmentContactQueueListApiArg = {
  /** Filter by managing paralegal ID */
  assigneeId?: string;
  /** Contact cadence in days (default: 14) */
  cadenceDays?: number;
  /** Minimum days since last contact */
  daysOverdueMin?: number;
  /** Maximum items to return (default: 100, max: 500) */
  limit?: number;
  /** Offset for pagination (default: 0) */
  offset?: number;
  /** Filter to items requiring attorney escalation */
  requiresEscalation?: boolean;
  /** Filter by urgency level(s): Routine, Overdue, Urgent, Escalate to Attorney */
  urgency?: string[];
};
export type TreatmentCheckInTaskSchema = {
  id: string | string;
  name: string;
  due_date?: string | null;
  is_overdue?: boolean;
};
export type ContactUrgency =
  | "Routine"
  | "Overdue"
  | "Urgent"
  | "Escalate to Attorney";
export type TreatmentContactQueueItem = {
  matter_id: string | string;
  matter_name: string;
  firm_id: string | string;
  firm_name: string;
  client_name: string;
  client_phone?: string | null;
  /** Days since last outbound SMS/call to client */
  days_since_last_contact?: number | null;
  /** Days since last inbound SMS from client */
  days_since_last_response?: number | null;
  /** Timestamp of last outbound contact */
  last_contacted_at?: string | null;
  /** Timestamp of last inbound SMS from client */
  last_client_response_at?: string | null;
  /** Associated treatment check-in task if exists */
  treatment_check_in_task?: TreatmentCheckInTaskSchema;
  /** Whether matter has an overdue treatment check-in task */
  has_overdue_check_in_task?: boolean;
  /** Names of approved medical providers */
  providers?: string[];
  /** Count of approved medical providers */
  approved_provider_count?: number;
  /** Computed urgency level */
  urgency?: ContactUrgency;
  /** True if client has not responded for 14+ days */
  requires_attorney_escalation?: boolean;
  managing_paralegal_id?: (string | string) | null;
  managing_paralegal_name?: string | null;
};
export type TreatmentContactQueueResponse = {
  items: TreatmentContactQueueItem[];
  /** Total number of items matching all filters */
  total_count: number;
  /** Count of ROUTINE urgency items (always 0 - see class docstring) */
  routine_count?: number;
  /** Count of OVERDUE urgency items in entire queue */
  overdue_count?: number;
  /** Count of URGENT urgency items in entire queue */
  urgent_count?: number;
  /** Count of ESCALATE_TO_ATTORNEY urgency items in entire queue */
  escalation_count?: number;
};
export const { useTreatmentContactQueueListQuery } = injectedRtkApi;
